/* eslint-disable */
export default {
  _asapbold: 'asapbold',
}